import React, {useEffect, useState} from 'react';
import {FlatList, StyleSheet, View} from 'react-native';
import {observer} from 'mobx-react';

import ContentView from '../components/ui-controls/layout/ContentView';
import {AirtablePromotionItem} from '../models/airtable';
import {AppRoute} from '../models/AppRoute';
import {RouteNavigatorScreenProps} from '../models/navigationTypes';
import {useStores} from '../stores/use-stores';
import theme from '../style/theme';

import PromotionDetailScreen from './articles/PromotionDetailScreen';

const OrderCompetitionScreen = observer(
  ({navigation}: RouteNavigatorScreenProps<AppRoute.PROMOTION>) => {
    const {cartStore} = useStores();

    const [promotionList, setPromotionList] = useState(
      cartStore.eligibleCompetitions,
    );

    useEffect(() => {
      if (!promotionList.length) {
        navigation.navigate(AppRoute.CART_ORDER_CONFIRMATION);
      }
    }, [navigation, promotionList]);

    const removeItem = (item: AirtablePromotionItem) => {
      const removed = promotionList.filter(act => act !== item);
      setPromotionList(removed);
    };

    const separator = () => <View style={styles.separator} />;

    const renderComp = ({item}: {item: AirtablePromotionItem}) => {
      const handleOnlineOrderAfterSubmitOrCancel = () => removeItem(item);

      return (
        <PromotionDetailScreen
          // @ts-ignore // missing: key, name
          route={{
            params: {
              promotion: item,
              orderNumber: cartStore.currentOrder.order_number,
              orderId: cartStore.currentOrder.id,
            },
          }}
          navigation={navigation}
          onOnlineOrderAfterSubmit={handleOnlineOrderAfterSubmitOrCancel}
          onOnlineOrderCancel={handleOnlineOrderAfterSubmitOrCancel}
          isLastCompetitionRemaining={promotionList.length === 1}
        />
      );
    };

    return (
      <ContentView
        style={styles.forcePadding}
        testID="order-competition-entry-screen">
        <FlatList
          data={promotionList}
          renderItem={renderComp}
          ItemSeparatorComponent={separator}
        />
      </ContentView>
    );
  },
);

export default OrderCompetitionScreen;

const styles = StyleSheet.create({
  forcePadding: {
    paddingHorizontal: 0,
  },
  separator: {
    marginVertical: 16,
    marginBottom: 8,
    borderTopWidth: 0.5,
    borderTopColor: theme.colour.border.appRoot.primary,
    marginHorizontal: 16,
  },
});
